import { render, staticRenderFns } from "./so.vue?vue&type=template&id=24a76149&"
import script from "./so.vue?vue&type=script&lang=js&"
export * from "./so.vue?vue&type=script&lang=js&"
import style0 from "./so.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports